import { ReactNode } from 'react'

import { Box, Section, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import users from 'modules/core/store/collections/users'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { TaskFile } from 'modules/tasks/hooks/useGetTaskFiles'
import { useMaterializedTaskItem } from 'modules/tasks/hooks/useMaterializedTaskItem'

import { TaskDetail } from '../TaskElement/useTaskDetail'
import Content from './Content'
import Info from './Info'

interface Props {
  task: TaskDetail
  assignees: ReactNode
  dueOn: string | null | undefined
  files: TaskFile[]
  loadingFiles: boolean
  affectee: ReactNode
  canSeePersonalInfo: boolean
  canEditPersonalInfo: boolean
  contractVersions: ContractVersions
  canEmployeeManageAnyEmployeeFolder: boolean
}

const TaskDetails = ({
  task,
  assignees,
  dueOn,
  files,
  loadingFiles,
  affectee,
  canSeePersonalInfo,
  canEditPersonalInfo,
  contractVersions,
  canEmployeeManageAnyEmployeeFolder,
}: Props) => {
  const { workflowOwnerId, stepName, mandatory, loading } = useMaterializedTaskItem({
    taskId: task.id,
  })

  const owner = users.get(workflowOwnerId ?? '')

  if (loading)
    return (
      <Box alignItems="center">
        <Spinner />
      </Box>
    )

  return (
    <Section.CustomTwoThirds
      primary={
        <Content
          files={files}
          loadingFiles={loadingFiles}
          task={task}
          owner={owner}
          canSeePersonalInfo={canSeePersonalInfo}
          canEditPersonalInfo={canEditPersonalInfo}
          contractVersions={contractVersions}
          canEmployeeManageAnyEmployeeFolder={canEmployeeManageAnyEmployeeFolder}
        />
      }
      secondary={
        <Info
          stepName={stepName}
          mandatory={mandatory}
          task={task}
          assignees={assignees}
          affectee={affectee}
          dueOn={dueOn}
        />
      }
    />
  )
}

export default observer(TaskDetails)
